<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
   
  }
}
</script>

<style scoped>
  @import "@/static/reset.css"; 
  
</style>

<style  lang="less">
#app {
    margin: 0px;
    padding: 0px;
    font-family: Microsoft YaHei, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, SimSun, sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
}
</style>
